import { useState } from "react";
import ReactDatePicker from "react-datepicker";
import styles from "../../styles/_sections/_orders/filter.module.scss";

const Filter = () => {
  const [orderDate, setOrderDate] = useState(new Date());

  return (
    <div className={styles.container}>
      {/* by ticket/attraction name */}
      <div className={styles.field}>
        <label>Filter by attraction name</label>
        <select name="ticketName">
          <option value="" selected disabled>
            Filter by attraction name{" "}
          </option>
          <option value="">Main attraction</option>
          <option value="">Main attraction</option>
          <option value="">Main attraction</option>
        </select>
      </div>

      {/* by date */}
      <div className={styles.field}>
        <label>Filter by date</label>
        <ReactDatePicker
          selected={orderDate}
          onChange={(date) => setOrderDate(date)}
        />
      </div>

      {/* by arrival time */}
      <div className={styles.field}>
        <label>Filter by arrival time</label>
        <select name="ticketName">
          <option value="" selected disabled>
            10:00
          </option>
          <option value="">9:00</option>
          <option value="">9:00</option>
          <option value="">9:00</option>
          <option value="">9:00</option>
        </select>
      </div>

      {/* by free search */}
      <div className={styles.field}>
        <label>Free Search</label>
        <input type="text" name="freeSearch" placeholder="Free Search" />
      </div>

      <button className={styles.btn}>Reset</button>
    </div>
  );
};

export default Filter;
